import { combineReducers } from 'redux';

const masterInitialState = {
  loadStatus: 0,
  list: null,
  query: {
    tab: '',
    size: 10,
  },
};

const cityInitialState = {
  loadStatus: 0,
  list: null,
  currentCity: {},
};

const storesInitialState = {
  loadStatus: 0,
  list: null,
  currentStore: {},
};

const editInitialState = {
  saveStatus: 0,
  input: {
    couponId: '',
    reserveCount: 1,
    reserveDate: '',
    reserveMobile: '',
    reserveName: '',
    reserveStoreId: '',
    reserveTimeEnd: '',
    reserveTimeStart: '',
    storeId: '',
  },
};

const locationSInitialState = {
  longitude: '',
  latitude: '',
};

const timesInitialState = {
  loadStatus: 0,
  list: null,
  query: {
    date: '',
  },
};

const couponInitialState = {
  loadStatus: 0,
  list: null,
};

function timesReducer(state = timesInitialState, action) {
  switch (action.type) {
    case 'LOAD_APPOINT_TIMES_LIST': {
      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_APPOINT_TIMES_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
          list: null,
        };
      }
      return {
        ...state,
        loadStatus: 2,
        list: action.data,
      };
    }
    default: {
      return state;
    }
  }
}

function masterReducer(state = masterInitialState, action) {
  switch (action.type) {
    case 'LOAD_APPOINT_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_APPOINT_LIST_COMPLETION': {
      const { error, willReload } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
          list: willReload ? null : state.list,
        };
      }

      const list = action.list.map(it => it.reserveCode);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: willReload ? list : (state.list || []).concat(list),
      };
    }

    default:
      return state;
  }
}

function cityListReducer(state = cityInitialState, action) {
  switch (action.type) {
    case 'LOAD_STORE_CITY_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        list: null,
      };
    }

    case 'LOAD_STORE_CITY_LIST_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
          list: null,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: data,
      };
    }

    case 'SET_CITY': {
      return {
        ...state,
        currentCity: action.data,
      };
    }

    default:
      return state;
  }
}

function storesReducer(state = storesInitialState, action) {
  switch (action.type) {
    case 'LOAD_SHOP_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        list: null,
      };
    }

    case 'LOAD_SHOP_LIST_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
          list: null,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: data,
      };
    }

    case 'SET_SHOP': {
      return {
        ...state,
        currentStore: action.data,
      };
    }

    default:
      return state;
  }
}

function editReducer(state = editInitialState, action) {
  switch (action.type) {
    case 'UPDATE_APPOINT_INPUT': {
      return {
        ...state,
        input: {
          ...(action.reset ? editInitialState.input : state.input),
          ...action.input,
        },
      };
    }

    case 'LOAD_APPOINT_TIMES_LIST': {
      return {
        ...state,
        input: {
          ...(action.reset ? editInitialState.input : state.input),
          reserveDate: action.query.reserveDate,
        },
      };
    }

    default:
      return state;
  }
}

function locationReducer(state = locationSInitialState, action) {
  switch (action.type) {
    case 'UPDATE_APPOINT_LOCATION': {
      if (action.reset) {
        return { ...locationSInitialState };
      }
      return {
        ...state,
        ...action.data,
      };
    }

    default:
      return state;
  }
}

function appointsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_APPOINT_LIST_COMPLETION': {
      if (action.error) {
        return state;
      }

      const appoints = action.list.reduce(
        (obj, appoint) => {
          const reserveCode = appoint.reserveCode;

          if (reserveCode) {
            obj[reserveCode] = { ...obj[reserveCode], ...appoint };
          }
          return obj;
        },
        { ...state }
      );

      return appoints;
    }

    case 'LOAD_APPOINT_COMPLETION': {
      const { reserveCode, data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [reserveCode]: data,
      };
    }

    case 'CREATE_APPOINT_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return state;
      }

      const reserveCode = data.reserveCode;
      if (error) {
        return state;
      }

      return {
        ...state,
        [reserveCode]: data,
      };
    }

    case 'CANCEL_APPOINT_COMPLETION': {
      if (action.error) {
        return state;
      }

      // const appoint = action.data;
      // const reserveCode = appoint.reserveCode;
      // const appoints = { ...state };

      // if (reserveCode) {
      //   appoints[reserveCode] = { ...appoints[reserveCode], ...appoint };
      // }

      // return appoints;
      return { ...state };
    }

    default:
      return state;
  }
}

function couponReducer(state = couponInitialState, action) {
  switch (action.type) {
    case 'LOAD_COUPON_LIST_BY_CHANNEL_CODE': {
      return {
        ...state,
        loadStatus: 1,
        list: null,
      };
    }

    case 'LOAD_COUPON_LIST_BY_CHANNEL_CODE_COMPLETION': {
      const { error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
          list: state.list,
        };
      }

      const list = action.list;

      return {
        ...state,
        loadStatus: 2,
        list: list,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  location: locationReducer,
  master: masterReducer,
  appoints: appointsReducer,
  // details: detailsReducer,
  edit: editReducer,
  citylists: cityListReducer,
  stores: storesReducer,
  times: timesReducer,
  coupon: couponReducer,
});
